import firstPartyAnalytics from './firstPartyAnalytics';
import { AnalyticsEvents, SponsorPlacement } from './analyticsEvents';

/**
 * Sponsor-Banner-Tracking im Tippspiel (Marcel 2026-09-22): Impressionen (je Sponsor,
 * Platzierung und Spiel EINMAL pro Sitzung) und Klicks (jedes Mal). Fail-soft.
 * Der Sender ist injizierbar (Tests).
 */
export interface SponsorRef {
  gameId: string | null | undefined;
  gameSlug?: string | null;
  sponsorId: string | null | undefined;
  sponsorTitle?: string | null;
  placement: SponsorPlacement;
}

type Sender = (name: string, params: Record<string, unknown>) => unknown;

export const createSponsorTracking = (send: Sender = (n, p) => firstPartyAnalytics.trackEvent(n, p)) => {
  const seen = new Set<string>();
  const params = (ref: SponsorRef) => ({
    game_id: ref.gameId ?? null,
    game_slug: ref.gameSlug ?? null,
    sponsor_id: ref.sponsorId ?? null,
    sponsor_title: ref.sponsorTitle ?? null,
    placement: ref.placement,
  });
  return {
    impression(ref: SponsorRef): boolean {
      if (!ref?.gameId || !ref?.sponsorId) return false;
      const key = `${ref.gameId}|${ref.sponsorId}|${ref.placement}`;
      if (seen.has(key)) return false;
      seen.add(key);
      try { void send(AnalyticsEvents.sponsorBannerImpression, params(ref)); } catch { /* nie werfen */ }
      return true;
    },
    click(ref: SponsorRef): void {
      if (!ref?.gameId || !ref?.sponsorId) return;
      try { void send(AnalyticsEvents.sponsorBannerClick, params(ref)); } catch { /* nie werfen */ }
    },
    reset(): void { seen.clear(); },
  };
};

const sponsorTracking = createSponsorTracking();
export default sponsorTracking;
